export default "__VITE_ASSET__e026af2d__$_?nuxt_component=async__"